import React, { useState, useEffect } from 'react';

function ProductionPlanModal({ date, onSave, onClose }) {
  const [planAmount, setPlanAmount] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const formatDate = (d) => {
    if (!d) return '—';
    const dateOnly = d.toString().split('T')[0];
    const [y, m, day] = dateOnly.split('-');
    return `${day}.${m}.${y}`;
  };

  // Загружаем существующий план
  useEffect(() => {
    fetch(`/api/production?date=${date}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.plan_amount !== null && data.plan_amount !== undefined) {
          setPlanAmount(String(data.plan_amount));
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [date]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const amount = parseInt(planAmount);
    if (isNaN(amount) || amount < 0) {
      setError('Введите число ≥ 0');
      return;
    }

    setSaving(true);

    try {
      const token = localStorage.getItem('token');
      const res = await fetch('/api/production', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          date,
          plan_amount: amount,
        })
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Ошибка сохранения');

      onSave();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>📦 План на {formatDate(date)}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>⏳ Загрузка...</div>
          ) : (
            <>
              <div className="form-group">
                <label>План на день (ланчбоксы) *</label>
                <input
                  type="number"
                  min="0"
                  value={planAmount}
                  onChange={(e) => setPlanAmount(e.target.value)}
                  placeholder="200000"
                  autoFocus
                  required
                />
              </div>

              {error && <div className="login-error">{error}</div>}

              <div className="modal-footer">
                <div className="modal-footer-right">
                  <button type="button" className="btn-cancel" onClick={onClose}>
                    Отмена
                  </button>
                  <button type="submit" className="btn-save" disabled={saving}>
                    {saving ? '⏳ Сохранение...' : 'Сохранить'}
                  </button>
                </div>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
}

export default ProductionPlanModal;